export default {
    ru: {
        EMPTY_FIELD: 'Поле обязательно к заполнению',
        INVALIDATED_EMAIL: 'Введите корректный адрес эл. почты',
        INVALIDATED_PHONE: 'Введите корректный номер телефона',
        INVALIDATED_EQUALS: 'Значение полей должно совпадать',
    },
    en: {
        EMPTY_FIELD: 'This field must not be empty',
        INVALIDATED_EMAIL: 'Enter a valid email address',
        INVALIDATED_PHONE: 'Enter a valid phone number',
        INVALIDATED_EQUALS: 'Values must be equal',
    },
};
